PREFIX rdf: <http://www.w3.org/1999/02/22-rdf-syntax-ns#>
PREFIX rdfs: <http://www.w3.org/2000/01/rdf-schema#>
PREFIX ccf: <http://purl.org/ccf/>
PREFIX cell: <http://purl.obolibrary.org/obo/CL_0000000>
PREFIX hasExactSynonym: <http://www.geneontology.org/formats/oboInOwl#hasExactSynonym>
PREFIX HRA: <https://purl.humanatlas.io/collection/hra-api>

SELECT DISTINCT ?root ?child ?parent ?label ?synonymLabel
FROM HRA:
WHERE {
  BIND(cell: as ?root)

  {
    BIND(cell: as ?child)
    BIND(cell: as ?parent)
  }
  UNION
  {
    ?child ccf:ccf_ct_isa ?parent .
  }

  ?child ccf:ccf_pref_label ?label1 .
  OPTIONAL {
    {
      ?child hasExactSynonym: ?synonymLabel1 .
    }
    UNION
    {
      ?child rdfs:label ?synonymLabel1 .
    }
  }
  FILTER (!isBlank(?child) && !isBlank(?parent))

  BIND(IF(?child = ?root, 'cell', STR(LCASE(?label1))) as ?label)
  BIND(STR(?synonymLabel1) as ?synonymLabel)
}
ORDER BY ?label ?child
